export default {
  meta: {
    title: '门店对比',
    url: '/stores/contrast', // 埋点用，记录所属模块
    // eventId: '53cee31d-130d-49de-8178-9577e793fced'
  },
};
